import { useState } from 'react';
import 'react-credit-cards/es/styles-compiled.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SalesInfoPix from 'SalesInfo/SalesInfoPix';
import Upsell from 'upsell/upsell';
import Checkout from './Checkout';
import Cookie from './cookie/';
import Delivery from './delivery/';

function App() {
  const [pixels, setPixels] = useState(null);

  return (
    <Router>
      <Routes>
        <Route
          path='/:uuidOffer'
          element={<Checkout pixels={pixels} setPixels={setPixels} />}
        />
        <Route
          path='/compra-realizada/:uuidSale'
          element={<Delivery pixels={pixels} setPixels={setPixels} />}
        />
        <Route
          path='/cookie/:destination/:uuidOffer/:uuidAffiliate'
          element={<Cookie />}
        />
        <Route
          path='/upsell/:uuidSaleItem/:uuidOffer'
          element={<Upsell />}
        ></Route>
        <Route
          path='/sales/pix/info/:uuidSaleItem'
          element={<SalesInfoPix />}
        ></Route>
      </Routes>
    </Router>
  );
}

export default App;
